import React from 'react';
import PropTypes from 'prop-types';
import './videoInfo.style.css';

export default function VideoInfo({ playlistmodel }) {
  return (
    <div id="title" className="tpx-video-info">
      <span>{playlistmodel.getItemSelected().title}</span>
      <span>
        {playlistmodel.getItemSelected().index + 1} de {playlistmodel.getTotalItems()}
      </span>
    </div>
  );
}

VideoInfo.propTypes = {
  playlistmodel: PropTypes.object.isRequired,
};
